import { CAUI, Component } from 'ca-ui';

export class VRWelcomePopup extends Component {
  static defaultOptions = {
    componentName: 'VRWelcomePopup'
  };

  constructor (vr, options, personOptions) {
    super($.extend({}, VRWelcomePopup.defaultOptions, options));
    this.vr = vr;
    this.personOptions = personOptions;

    this.shim = $('<div class="' + this.getComponentClass() + '_shim"></div>');
    $(document.body).append(this.shim);

    this.shim.on('click', () => {
      this.vr.hideWelcome();
    });

    this.container = $(
      '<div class="' + this.getComponentClass() + '_container"></div>'
    );
    this.el.append(this.container);

    // person addition for ca-ver
    if (this.personOptions !== undefined && vr.options.showWelcomePerson) {
      this.personDisplay = $(`<div class='ca-ui-vrwelcomepopup_person-container'><img src='${this.personOptions.imgSrc}'></div>`);
      this.container.append(this.personDisplay);
    }

    if (this.options.heading === undefined) {
      this.heading = $(`<div class='ca-ui-vrwelcomepopup_header'>${options.metadata.children[1].children[0].value}</div>`);
    } else {
      this.heading = $('<h1>' + CAUI.renderText(this.options.heading) + '</h1>');
    }

    this.container.append(this.heading);

    this.contentToUse = options.metadata.children[2].children[0].value;
    if (this.options.text === undefined) {
      this.content = $(`<div class="${this.getComponentClass()}_content">${this.contentToUse}</div>`);
    } else {
      this.content = $(
        '<div class="' +
          this.getComponentClass() +
          '_content">' +
          CAUI.renderText(this.options.text) +
          '</div>'
      );
    }
    this.container.append(this.content);

    this.buttonContainer = $(
      '<div class="' + this.getComponentClass() + '_buttoncontainer"></div>'
    );
    this.container.append(this.buttonContainer);

    this.enterButton = $(
      `<button style='background-color: ${vr.options.welcomeCTAButtonColour !== undefined && vr.options.welcomeCTAButtonColour !== null && vr.options.welcomeCTAButtonColour !== 'null' ? vr.options.welcomeCTAButtonColour : '#316ae3'}' class="btn btn-primary ${this.getComponentClass()}-enterbutton">
      ${vr.options.welcomeCTAtext !== undefined && vr.options.welcomeCTAtext !== null && vr.options.welcomeCTAtext !== 'null' ? vr.options.welcomeCTAtext : 'Enter room'}</button>`
    );
    this.buttonContainer.append(this.enterButton);

    this.enterButton.on('click', () => {
      this.vr.hideWelcome();
    });

    this.el.on('mousedown', () => {
      return false;
    });

    this.el.on('mousemove', () => {
      return false;
    });
  }

  open () {
    this.el.addClass(this.getComponentClass() + '--showing');
  }

  close () {
    this.el.removeClass(this.getComponentClass() + '--showing');
  }

  position (overlay) {
    // support ppl facing left here
    if (overlay !== undefined) {
      this.targetOverlay = overlay;

      const rect = overlay.assetContainer[0].getBoundingClientRect();

      let top = rect.top;
      let right = document.documentElement.clientWidth - rect.left;
      const left = Math.max(right - 500 + 230, 230);
      if (this.options.offset) {
        top += this.options.offset.y;
        right += this.options.offset.x;
      }

      this.el.css('left', left);
      this.el.css('right', right);
      this.el.css('top', top);

      const welcomeRect = this.el[0].getBoundingClientRect();

      const path =
        'M4,0 h' +
        (welcomeRect.width - 30) +
        ' a4,4 0 0 1 4,4 v100 L' +
        (welcomeRect.width - 2) +
        ',120 L' +
        (welcomeRect.width - 22) +
        ',140 v' +
        (welcomeRect.height - 150) +
        ' a4,4 0 0 1 -4,4 h-' +
        (welcomeRect.width - 30) +
        ' a4,4 0 0 1 -4,-4 v-' +
        (welcomeRect.height - 14) +
        ' a4,4 0 0 1 4,-4 z';
      this.container.css('clip-path', "path('" + path + "')");
    }
  }

  layout () {
    this.position(this.targetOverlay);
  }
}
